<template>
    <VListSubheader>Global Font</VListSubheader>
    <VSelect rounded="lg" color="primary" variant="solo-filled" v-model="store.globalFont" :items="themeFonts"
        :menu-props="{ contentClass: 'rounded-lg' }" flat />
</template>


<script setup lang="ts">
import { useAppStore } from '@S/appStore';

let store = useAppStore();

const themeFonts = [
    {
        title: 'Inter',
        value: 'Inter'
    },
    {
        title: 'Roboto',
        value: 'Roboto'
    },
    {
        title: 'Rubik',
        value: 'Rubik'
    },
    {
        title: 'Ubuntu',
        value: 'Ubuntu'
    },
    {
        title: 'Arial',
        value: 'Arial'
    },
    {
        title: 'Comic Sans',
        value: 'Comic Relief'
    }
];
</script>